import { ApiRequest } from '../../apiRequest'
import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import {
    fetchLastConfigurationsInfo,
    fetchLastConfigurationsForDate,
    setLastConfigurationsAvailabilities,
    setLastConfigurationsMerge,
    setLastConfigurationsLoadingDate,
    fetchLastConfigurationsAvailabilitiesAsync,
    fetchLastConfigurationsForDateAsync,
} from '../../actions/app/lastConfigurations.actions'
import {
    getLastConfigurationsAvailabilitiesApiUrl,
    getLastConfigurationsWithDateRangeApiUrl,
} from '../../../constants/apiUrls'

const lastConfigurationsMiddleware =
    (apiRequest: ApiRequest): Middleware => (store) => (next) => (action) => {
        next(action)
        const { dispatch, getState } = store

        if (isActionOf(fetchLastConfigurationsInfo, action)) {
            const availabilitiesUrl = getLastConfigurationsAvailabilitiesApiUrl()
            apiRequest(
                {
                    options: {
                        url: availabilitiesUrl,
                        method: 'GET',
                    },
                    asyncActions: fetchLastConfigurationsAvailabilitiesAsync,
                    causedBy: action,
                },
                dispatch,
            )
        }

        if (isActionOf(fetchLastConfigurationsAvailabilitiesAsync.success, action)) {
            const list = (action.payload.lastConfigurationsAvailabilities ?? []).map((item) => ({
                date: item.date,
                numberOfAvailableConfigurations: item.numberOfAvailableConfigurations,
            }))
            const sortedByDate = [...list].sort((a, b) => a.date.localeCompare(b.date))
            const latestDate = sortedByDate.length > 0 ? sortedByDate[sortedByDate.length - 1].date : null

            dispatch(setLastConfigurationsAvailabilities(sortedByDate))

            if (latestDate != null) {
                dispatch(fetchLastConfigurationsForDate(latestDate))
            }
        }

        if (isActionOf(fetchLastConfigurationsForDate, action)) {
            const date = action.payload
            dispatch(setLastConfigurationsLoadingDate(date))
            const dateFrom = `${date}T00:00:00`
            const dateTo = `${date}T23:59:59`
            const configurationsUrl = getLastConfigurationsWithDateRangeApiUrl(dateFrom, dateTo)
            apiRequest(
                {
                    options: {
                        url: configurationsUrl,
                        method: 'GET',
                    },
                    asyncActions: fetchLastConfigurationsForDateAsync,
                    causedBy: action,
                },
                dispatch,
            )
        }

        if (isActionOf(fetchLastConfigurationsForDateAsync.success, action)) {
            const items = action.payload.lastConfigurations ?? []
            dispatch(setLastConfigurationsMerge(items))
            const loadingDate = getState().lastConfigurationsInfo?.lastConfigurationsLoadingDate
            const completedForCurrentLoadingDate =
                loadingDate != null && items.some((lc) => lc.date === loadingDate)
            if (completedForCurrentLoadingDate) {
                dispatch(setLastConfigurationsLoadingDate(null))
            }
        }

        if (isActionOf(fetchLastConfigurationsForDateAsync.failure, action)) {
            dispatch(setLastConfigurationsLoadingDate(null))
        }
    }

export default lastConfigurationsMiddleware
